import NoProjects from 'components/shared/NoProjects/NoProjects'
import ProjectCard from 'components/shared/ProjectCard/ProjectCard'
import PropTypes from 'prop-types'

import './ProjectList.scss'

const ProjectList = ({ display, projects, locale, loading, gtm }) => {
  if (projects.length === 0 && !loading) {
    return <NoProjects display={display} locale={locale} />
  }

  return (
    <div className="project-list">
      {projects.map((project, i) => (
        <ProjectCard key={i} locale={locale} project={project} gtm={gtm} />
      ))}
    </div>
  )
}

ProjectList.propTypes = {
  display: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  projects: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  gtm: PropTypes.object,
}

export default ProjectList
